// @flow
import './utils/fixStorages'
import setConfig from './config'
import * as places from './services/places'
import * as currencies from './services/currencies'
import * as logs from './services/logs'
import * as deeplink from './services/deeplink'
import * as user from './services/user'
import * as auth from './services/auth'
import * as reservations from './services/reservations'
import * as pickups from './services/pickups'
import * as trips from './services/trips'
import * as tracking from './services/tracking'
import * as vehicles from './services/vehicles'
import * as creditcard from './services/creditcard'
import * as flights from './services/flights'
import * as corporate from './services/corporate'
import * as engage from './services/engage'
import * as travelagent from './services/travelagent'
import * as providers from './services/providers'
import * as favouritePlaces from './services/favouritePlaces'
import errorCodes from './errorCodes'
import APIError from './client/APIError'
import { CATEGORIES_FILTERS, CATEGORIES_ENUM } from './constants/categories'
import { AMENITY_IDS } from './constants/amenities'
import { SORTER_ENUM, SORTER_FUNCTIONS } from './constants/sorter'
import { CREDIT_CARD_TYPES } from './constants/creditCardType'
import { STEP_TYPE } from './constants/stepType'
import { TRIP_TYPE } from './constants/tripType'

const constants = {
  CATEGORIES_ENUM,
  CATEGORIES_FILTERS,
  AMENITY_IDS,
  SORTER_ENUM,
  SORTER_FUNCTIONS,
  CREDIT_CARD_TYPES,
  TRIP_TYPE,
  STEP_TYPE,
}

export {
  vehicles,
  tracking,
  places,
  currencies,
  logs,
  deeplink,
  user,
  auth,
  reservations,
  trips,
  creditcard,
  flights,
  corporate,
  engage,
  travelagent,
  providers,
  favouritePlaces,
  pickups,
  errorCodes,
  setConfig,
  constants,
  APIError,
}
